export default "__VITE_ASSET__90f0021c__"